export default __webpack_public_path__ + "images/XW.86de38c.png";